import { Component, OnInit } from '@angular/core';
declare var $:any
@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {

  constructor() { }

  ngOnInit() {

    $('.expanded').click(function() {
      $(this).find('i').toggleClass('fa fa-chevron-up fa fa-chevron-down');
  });

    $(document).ready(function(){
    
$('.archive_year > li').click(function() {

	$(this).find('ul').slideToggle();
	 
});

$('.archive_month > li').click(function() {
    $(this).parent().find('ul').slideToggle();
});
 
 $('#dvQues').click(function(){
	$('#ulQuesList').slideToggle();
 });
 $('#dvQues1').click(function(){
	$('#ulQuesList1').slideToggle();
 });
  $('#dvQues2').click(function(){
	$('#ulQuesList2').slideToggle();
 });
  $('#dvQues3').click(function(){
	$('#ulQuesList3').slideToggle();
 });
  $('#dvQues4').click(function(){
	$('#ulQuesList4').slideToggle();
 });
  $('#dvQues5').click(function(){
	$('#ulQuesList5').slideToggle();
 });
 
  $('#dvQues6').click(function(){
	$('#ulQuesList6').slideToggle();
 });
 
   $('#dvQues7').click(function(){
	$('#ulQuesList7').slideToggle();
 });
    $('#dvQues8').click(function(){
	$('#ulQuesList8').slideToggle();
 });
$('.archive_year').hide();

});


  }

}
